<template>
  <div>
    <v-row>
      <v-col cols="11">
        <v-simple-table dense v-if="benefits && content">
          <template v-slot:default>
            <thead>
              <tr>
                <th
                  v-for="header in tableHeaders"
                  :key="header.name"
                  class="text-left"
                >
                  <p>{{ header.text }}</p>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item, count) in tableBenefits"
                :key="`${item.title}-${count}`"
              >
                <td @click="showOverlay(item.title)" role="button">
                  {{ item.title }}
                </td>
                <td
                  v-for="(a, index) in item.audiences"
                  :key="`${item.name}-${a}-${index}`"
                >
                  <v-icon v-if="a.tick" color="amber" v-bind="attrs" v-on="on"
                    >mdi-circle</v-icon
                  >
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
      <v-col cols="2">
        <v-card light>
          <v-card-title>{{ selectedItem.title }}</v-card-title>
          <v-card-text>
            <p v-text="selectedItem.description"></p>
            <p class="overline">Items</p>
            <ul>
              <li v-for="item in selectedItem.items" :key="item">{{ item }}</li>
            </ul>
            <p class="overline">Attributes</p>
            <ul>
              <li v-for="item in selectedItem.attributes" :key="item">
                {{ item }}
              </li>
            </ul>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- <pre>{{ benefits }}</pre> -->
  </div>
</template>

<script>
// import lodash from "lodash";
const fb = require("@/firebaseConfig.js");

export default {
  name: "ResultsUnitTable",

  async created() {
    // GET request using fetch with async/await
    const response = await fetch(`/content/${this.$route.params.id}.json`);
    const data = await response.json();
    this.content = data;
    this.getAudiences();
  },

  data() {
    return {
      content: null,
      audiencesFromExercise: null,
      selectedItem: {},
    };
  },
  props: {
    attributes: {
      type: Array,
      default: () => {},
    },
    benefits: {
      type: Array,
      default: () => {},
    },
    showControls: {
      type: Boolean,
      default: true,
    },
    showDelete: {
      type: Boolean,
      default: true,
    },
    lang: {
      type: String,
      default: "exercise_benefits_bl",
    },
  },

  computed: {
    tableHeaders() {
      if (this.audiences) {
        const headers = [{ text: "Benefit", value: "name", align: "start" }];
        this.audiences.forEach((x) => {
          headers.push({
            text: x.title,
            value: x.title,
          });
        });
        return headers;
      } else {
        return [];
      }
    },
    tableBenefits() {
      if (this.benefits) {
        const benefits = [];

        this.benefits.forEach((x) => {
          const arr = [];
          this.audiences.forEach((a) => {
            arr.push({
              title: a.title,
              tick: x.audience.filter((z) => z === a.title).length
                ? true
                : false,
            });
          });

          benefits.push({
            title: x.title,
            audiences: arr,
          });
        });

        return benefits;
      } else {
        return [];
      }
    },
    audiences() {
      if (this.content && this.audiencesFromExercise) {
        console.log("get audiences from exercise");
        return this.content.exercise_benefits.getAudiencesFromExercise
          ? this.audiencesFromExercise
          : this.content.exercise_benefits.step1.dropdown;
      } else {
        return this.content.exercise_benefits.step1.dropdown;
      }
    },
  },

  methods: {
    showOverlay(title) {
      const item = this.benefits.find((x) => x.title === title);
      if (item) {
        this.selectedItem = item;
      }
    },
    getAudiences() {
      let ref = fb.audienceExCollection.where(
        "pid",
        "==",
        this.$route.params.id
      );
      ref
        .get()
        .then((result) => {
          let items = [];
          result.docs.forEach((doc) => {
            let post = doc.data();
            items.push(post);
          });
          if (items && items.length) {
            const body = items[0].doc.matrix;
            this.audiencesFromExercise = [...body.q1, ...body.q2, ...body.q3];
          }
        })
        .catch(function() {});
    },
  },
};
</script>

<style lang="scss" scoped>
.v-data-table {
  overflow: visible !important;
  .v-data-table__wrapper {
    overflow: visible !important;
  }
  margin-top: 300px;
  th,
  tr,
  td {
    vertical-align: top !important;
    padding: 1px !important;
    position: relative;
    &:first-child {
      width: 15%;
    }
  }
  th p {
    transform: rotate(-60deg) !important;
    text-align: left;
    transform-origin: left;
    position: absolute;
    left: 10px;
    bottom: 10px;
    width: 300px;
    z-index: 100;
    padding: 0px;
    margin: 0px;
    color: white;
  }
}
</style>
